window.addEventListener("load", function () {
  var TeamBuilder = (function ($) {
    // ============ FORMATION CONFIGS ============
    // Mỗi formation có 11 vị trí (index 0-10), top/left tính theo %
    var formations = {
      442: [
        { top: 87, left: 50, label: "GK" },
        { top: 60, left: 16, label: "LB" },
        { top: 66, left: 39, label: "CB" },
        { top: 66, left: 61, label: "CB" },
        { top: 60, left: 84, label: "RB" },
        { top: 36, left: 16, label: "LM" },
        { top: 41, left: 39, label: "CM" },
        { top: 41, left: 61, label: "CM" },
        { top: 36, left: 84, label: "RM" },
        { top: 18, left: 39, label: "ST" },
        { top: 18, left: 61, label: "ST" },
      ],
      433: [
        { top: 87, left: 50, label: "GK" },
        { top: 60, left: 16, label: "LB" },
        { top: 66, left: 39, label: "CB" },
        { top: 66, left: 61, label: "CB" },
        { top: 60, left: 84, label: "RB" },
        { top: 41, left: 28, label: "CM" },
        { top: 44, left: 50, label: "CM" },
        { top: 41, left: 72, label: "CM" },
        { top: 16, left: 20, label: "LW" },
        { top: 12, left: 50, label: "ST" },
        { top: 16, left: 80, label: "RW" },
      ],
      523: [
        { top: 87, left: 50, label: "GK" },
        { top: 58, left: 10, label: "LWB" },
        { top: 66, left: 30, label: "CB" },
        { top: 68, left: 50, label: "CB" },
        { top: 66, left: 70, label: "CB" },
        { top: 58, left: 90, label: "RWB" },
        { top: 41, left: 38, label: "CM" },
        { top: 41, left: 62, label: "CM" },
        { top: 16, left: 20, label: "LW" },
        { top: 12, left: 50, label: "ST" },
        { top: 16, left: 80, label: "RW" },
      ],
      4123: [
        { top: 87, left: 50, label: "GK" },
        { top: 60, left: 16, label: "LB" },
        { top: 66, left: 39, label: "CB" },
        { top: 66, left: 61, label: "CB" },
        { top: 60, left: 84, label: "RB" },
        { top: 48, left: 50, label: "CDM" },
        { top: 33, left: 33, label: "CM" },
        { top: 33, left: 67, label: "CM" },
        { top: 16, left: 20, label: "LW" },
        { top: 12, left: 50, label: "ST" },
        { top: 16, left: 80, label: "RW" },
      ],
      352: [
        { top: 87, left: 50, label: "GK" },
        { top: 64, left: 28, label: "CB" },
        { top: 66, left: 50, label: "CB" },
        { top: 64, left: 72, label: "CB" },
        { top: 36, left: 10, label: "LM" },
        { top: 41, left: 30, label: "CM" },
        { top: 45, left: 50, label: "CM" },
        { top: 41, left: 70, label: "CM" },
        { top: 36, left: 90, label: "RM" },
        { top: 12, left: 39, label: "ST" },
        { top: 12, left: 61, label: "ST" },
      ],
    };

    // ============ STATE ============
    // null = chưa chọn, object = đã chọn { id, name, avatar }
    var playerSlots = new Array(11).fill(null);
    var $board = $(".builder__center--board");
    var $select = $("#builder-select");
    var cdnBase = window.baseLinkCDN || "";

    var defaultCardSrc =
      $board.find(".builder__default-card").attr("src") ||
      cdnBase + "assets/tf-26-preregister-builder/images/card.png";

    // ============ GENERATE BOARD ============
    function generateBoard() {
      $board.empty();
      for (var i = 0; i < 11; i++) {
        var html =
          '<a href="#" class="builder__center--board-player" data-index="' +
          i +
          '" data-state="empty">' +
          '<img src="' +
          defaultCardSrc +
          '" class="player__image" alt=""/>' +
          '<div class="player__action">' +
          '<span class="player__action--remove" role="button" tabindex="0"></span>' +
          '<span class="player__action--change" role="button" tabindex="0"></span>' +
          "</div>" +
          "</a>";
        $board.append(html);
      }
    }

    // ============ APPLY FORMATION ============
    function applyFormation(formationKey) {
      var config = formations[formationKey];
      if (!config) return;

      $board.attr("data-build", formationKey);

      $board.find(".builder__center--board-player").each(function () {
        var index = parseInt($(this).attr("data-index"), 10);
        var pos = config[index];
        if (!pos) return;

        $(this).css({
          top: pos.top + "%",
          left: pos.left + "%",
        });
      });
    }

    // ============ RENDER PLAYER STATE ============
    function renderPlayer($slot, index) {
      var data = playerSlots[index];

      if (!data) {
        // Trạng thái trống
        $slot.attr("data-state", "empty");
        $slot.find(".player__image").attr("src", defaultCardSrc);
        $slot.find(".player__action").hide();
      } else {
        // Đã chọn cầu thủ
        $slot.attr("data-state", "filled");
        $slot.find(".player__image").attr("src", data.avatar || defaultCardSrc);
        $slot.find(".player__action").show();
      }
    }

    function renderAllPlayers() {
      $board.find(".builder__center--board-player").each(function () {
        var index = parseInt($(this).attr("data-index"), 10);
        renderPlayer($(this), index);
      });
    }

    // ============ UPDATE DOWNLOAD BUTTON STATE ============
    function updateDownloadButton() {
      var allFilled = playerSlots.every(function (slot) {
        return slot !== null;
      });
      var $btn = $(".btn__download");
      if (allFilled) {
        $btn.removeClass("is-disabled");
      } else {
        $btn.addClass("is-disabled");
      }
    }

    // ============ SET PLAYER ============
    function setPlayer(index, playerData) {
      // playerData: { id, name, avatar }
      playerSlots[index] = playerData;
      var $slot = $board.find(
        '.builder__center--board-player[data-index="' + index + '"]',
      );
      renderPlayer($slot, index);
      updateDownloadButton();
    }

    // ============ REMOVE PLAYER ============
    function removePlayer(index) {
      playerSlots[index] = null;
      var $slot = $board.find(
        '.builder__center--board-player[data-index="' + index + '"]',
      );
      renderPlayer($slot, index);
      updateDownloadButton();
    }

    // ============ GET HELPERS ============
    function getCurrentFormation() {
      return $select.val();
    }

    function getPositionLabel(index) {
      var formationKey = getCurrentFormation();
      var config = formations[formationKey];
      return config && config[index] ? config[index].label : "";
    }

    // ============ LOAD IMAGES HELPER ============
    function loadAllImages(urls, callback) {
      var loaded = {};
      var count = 0;
      var unique = urls.filter(function (u, i, arr) {
        return u && arr.indexOf(u) === i;
      });
      var total = unique.length;
      if (total === 0) {
        callback(loaded);
        return;
      }
      unique.forEach(function (url) {
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = function () {
          loaded[url] = img;
          count++;
          if (count === total) callback(loaded);
        };
        img.onerror = function () {
          count++;
          if (count === total) callback(loaded);
        };
        img.src = url;
      });
    }

    // ============ DOWNLOAD IMAGE CONSTANTS (px) ============
    // Tọa độ cố định theo ảnh download 1080×1080 (builder-[locale].jpg)
    // Board giữ nguyên kích thước gốc, căn giữa trong canvas
    var PC = {
      W: 1080,
      H: 1080,
      BOARD_X: (1080 - 622) / 2, // 229
      BOARD_Y: (1080 - 860) / 2, // 150.5
      BOARD_W: 622,
      BOARD_H: 779,
      CARD_W: 111,
      CARD_H: 148,
    };

    // ============ RESOLVE IMAGE FORMAT ============
    // Thử load lần lượt các URL, trả về URL đầu tiên load thành công
    function resolveImageSrc(candidates, callback) {
      var idx = 0;
      function tryNext() {
        if (idx >= candidates.length) {
          callback(null);
          return;
        }
        var img = new Image();
        img.onload = function () {
          callback(candidates[idx]);
        };
        img.onerror = function () {
          idx++;
          tryNext();
        };
        img.src = candidates[idx];
      }
      tryNext();
    }

    // Tạo danh sách URL thử cho ảnh: optimized (webp, jpg, png) → assets (jpg, webp, png)
    var IMG_FOLDERS = ["optimized/", "assets/"];
    var IMG_EXTS = [".webp", ".jpg", ".png"];

    function buildCandidates(folderAndFile) {
      // folderAndFile ví dụ: "tf-26-preregister-builder/images/bg-vn"
      var list = [];
      IMG_FOLDERS.forEach(function (folder) {
        IMG_EXTS.forEach(function (ext) {
          list.push(cdnBase + folder + folderAndFile + ext);
        });
      });
      return list;
    }

    // ============ DOWNLOAD ============
    function downloadImage() {
      var locale = document.body.className.trim().split(/\s+/)[0] || "en";
      var candidates = buildCandidates(
        "tf-26-preregister-builder/images/builder-" + locale,
      );

      resolveImageSrc(candidates, function (bgSrc) {
        if (!bgSrc) return;
        _doDownload(bgSrc);
      });
    }

    function _doDownload(bgSrc) {
      // Lấy URL board.png từ computed CSS
      var boardBgRaw = $board.css("background-image") || "";
      var boardBgUrl = boardBgRaw
        .replace(/url\(["']?/, "")
        .replace(/["']?\)/, "");

      var $firstPlayer = $board.find(".builder__center--board-player").first();
      var cardBgUrl =
        $firstPlayer.find(".player__image").attr("src") || defaultCardSrc;

      // Collect tất cả ảnh cần load
      var imagesToLoad = [bgSrc, boardBgUrl, cardBgUrl];
      playerSlots.forEach(function (slot) {
        if (slot && slot.avatar) {
          imagesToLoad.push(slot.avatar);
        }
      });

      loadAllImages(imagesToLoad, function (imgs) {
        var bgImg = imgs[bgSrc];
        var boardImg = imgs[boardBgUrl];
        var cardImg = imgs[cardBgUrl];
        if (!bgImg) return;

        var canvas = document.createElement("canvas");
        canvas.width = bgImg.naturalWidth;
        canvas.height = bgImg.naturalHeight;
        var ctx = canvas.getContext("2d");

        // 1. Vẽ background
        ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);

        // 2. Tính vị trí board theo tọa độ PC design (luôn giống PC)
        var scaleX = canvas.width / PC.W;
        var scaleY = canvas.height / PC.H;

        var bx = PC.BOARD_X * scaleX;
        var by = PC.BOARD_Y * scaleY;
        var bw = PC.BOARD_W * scaleX;
        var bh = PC.BOARD_H * scaleY;

        // 3. Vẽ board (sân bóng)
        if (boardImg) {
          ctx.drawImage(boardImg, bx, by, bw, bh);
        }

        // 4. Vẽ từng player card
        var formationKey = getCurrentFormation();
        var config = formations[formationKey];
        var cardW = (PC.CARD_W / PC.BOARD_W) * bw;
        var cardH = (PC.CARD_H / PC.BOARD_H) * bh;

        config.forEach(function (pos, index) {
          var cx = bx + (pos.left / 100) * bw - cardW / 2;
          var cy = by + (pos.top / 100) * bh - cardH / 2;

          var slot = playerSlots[index];
          if (slot && slot.avatar && imgs[slot.avatar]) {
            ctx.drawImage(imgs[slot.avatar], cx, cy, cardW, cardH);
          } else if (cardImg) {
            ctx.drawImage(cardImg, cx, cy, cardW, cardH);
          }
        });

        // 5. Vẽ formation label ở góc dưới bên trái board
        var formationText = $select.find("option:selected").text() || "";
        // Đổi dấu "-" thành ":" cho style giống demo
        formationText = formationText.replace(/-/g, ":");
        if (formationText) {
          var fontSize = Math.round(bw * 0.038);
          var padX = Math.round(fontSize * 0.6);
          var padY = Math.round(fontSize * 0.35);
          ctx.font = "bold " + fontSize + "px sans-serif";
          var textW = ctx.measureText(formationText).width;
          var labelW = textW + padX * 2;
          var labelH = fontSize + padY * 2;
          var labelX = bx;
          var labelY = by + bh - labelH;

          // Background badge
          ctx.fillStyle = "rgba(0, 0, 0, 1)";
          ctx.beginPath();
          var r = Math.round(fontSize * 0.25);
          ctx.moveTo(labelX + r, labelY);
          ctx.lineTo(labelX + labelW - r, labelY);
          ctx.quadraticCurveTo(
            labelX + labelW,
            labelY,
            labelX + labelW,
            labelY + r,
          );
          ctx.lineTo(labelX + labelW, labelY + labelH - r);
          ctx.quadraticCurveTo(
            labelX + labelW,
            labelY + labelH,
            labelX + labelW - r,
            labelY + labelH,
          );
          ctx.lineTo(labelX + r, labelY + labelH);
          ctx.quadraticCurveTo(
            labelX,
            labelY + labelH,
            labelX,
            labelY + labelH - r,
          );
          ctx.lineTo(labelX, labelY + r);
          ctx.quadraticCurveTo(labelX, labelY, labelX + r, labelY);
          ctx.closePath();
          ctx.fill();

          // Text
          ctx.fillStyle = "#34e3f8";
          ctx.textBaseline = "middle";
          ctx.fillText(formationText, labelX + padX, labelY + labelH / 2);
        }

        // 6. Download
        var link = document.createElement("a");
        link.download = "my-team-" + formationKey + ".png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    }

    // ============ EVENTS ============
    function bindEvents() {
      // Click vào .group__select mở select dropdown
      $(".group__select").on("click", function (e) {
        if (e.target.tagName !== "SELECT") {
          var sel = $(this).find("select")[0];
          if (sel && typeof sel.showPicker === "function") {
            sel.showPicker();
          } else if (sel) {
            sel.focus();
            var evt = new MouseEvent("mousedown", { bubbles: true });
            sel.dispatchEvent(evt);
          }
        }
      });

      // Đổi đội hình
      $select.on("change", function () {
        applyFormation($(this).val());
      });

      // Click card để thêm/đổi cầu thủ
      $board.on("click", ".builder__center--board-player", function (e) {
        e.preventDefault();
        var $slot = $(this);

        // Slot đã có cầu thủ thì không mở popup bằng click card,
        // chỉ cho thao tác qua nút remove/change.
        if ($slot.attr("data-state") === "filled") return;

        var index = parseInt($slot.attr("data-index"), 10);
        var posLabel = getPositionLabel(index);
        // Trigger event để mở popup chọn cầu thủ
        $(document).trigger("builder:openSelectPlayer", [index, posLabel]);
      });

      // Click xóa cầu thủ
      $board.on("click", ".player__action--remove", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $slot = $(this).closest(".builder__center--board-player");
        var index = parseInt($slot.attr("data-index"), 10);
        removePlayer(index);
      });

      // Click đổi cầu thủ
      $board.on("click", ".player__action--change", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $slot = $(this).closest(".builder__center--board-player");
        var index = parseInt($slot.attr("data-index"), 10);
        var posLabel = getPositionLabel(index);
        $(document).trigger("builder:openSelectPlayer", [index, posLabel]);
      });

      // Click download
      $(".btn__download").on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("is-disabled")) return;
        downloadImage();
      });
    }

    // ============ INIT ============
    function init() {
      generateBoard();
      var defaultFormation = $select.val() || "442";
      applyFormation(defaultFormation);
      renderAllPlayers();
      bindEvents();
      updateDownloadButton();
    }

    // ============ PUBLIC API ============
    return {
      init: init,
      setPlayer: setPlayer,
      removePlayer: removePlayer,
      getSlots: function () {
        return playerSlots;
      },
      applyFormation: applyFormation,
      formations: formations,
    };
  })($);

  // Khởi tạo
  TeamBuilder.init();

  // ============ USAGE ============
  // Khi popup trả về kết quả cầu thủ, gọi:
  // TeamBuilder.setPlayer(index, { id: "p01", name: "Messi", avatar: "path/to/img.png" });
  //
  // Lắng nghe event mở popup:
  // $(document).on("builder:openSelectPlayer", function (e, , posLabel) {
  //     // Mở popup chọn cầu thủ cho vị trí index
  // });

  window.TeamBuilder = TeamBuilder;
});
